
<script setup>
import { computed } from 'vue'




// MUST use full path, not @/
const requireImages = require.context('@/assets/img/illustrations', false, /\.png$/)
const imageMap = {}
requireImages.keys().forEach((key) => {
    const fileName = key.replace('./', '')
    imageMap[fileName] = requireImages(key)
})


const props = defineProps({
    rutaImagen: String // e.g. 'avatar_con_martillero.png'
})
const urlImagen = computed(() => imageMap[props.rutaImagen])

</script>
<template>
  <div class="modal fade" id="instruccionesModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-custom modal-dialog-centered">
      <div class="modal-content text-center p-5 position-relative">
        <!-- Botón de cierre -->
        <button type="button" 
                class="position-absolute top-0 end-0 m-2 bg-light border-0 rounded-circle d-flex align-items-center justify-content-center"
                style="width: 40px; height: 40px;"
                aria-label="Close"
                data-bs-dismiss="modal">
          <span class="fs-4">&times;</span>
        </button>
        <div class="columna_flex">
          <img
            class="img_flex"
            :src="urlImagen" 
            :alt="props.rutaImagen" 
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.modal-content {
    border-radius: 10px;
    border: none;
}
.modal-custom{
    min-width: 90% !important;
}
.columna_flex {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
}
.img_flex{
    object-fit:fill;
}
.bg-success {
    background-color: #28a745 !important;
}
</style>